import { LocationTypeForSelect } from "../../Forms/LocationSelect/LocationTypeForSelect";

export const locationTypesForContact: LocationTypeForSelect[] = [
  { Id: 0, LocationType: "Supplier" },
  { Id: 1, LocationType: "Plant" },
  { Id: 2, LocationType: "ODC" },
  { Id: 5, LocationType: "Carrier Branch" },
  { Id: 6, LocationType: "EDC" },
];

export enum LocationTypeForContactEnum {
  Supplier = 0,
  Plant = 1,
  ODC = 2,
  CarrierBranch = 5,
  EDC = 6,
}
